import type { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";

type LaunchPadSectionProps = {
  title: string;
  description?: string;
  children: ReactNode;
  showSeparator?: boolean;
  headingId: string;
  testId?: string;
};

export function LaunchPadSection({
  title,
  description,
  children,
  showSeparator = true,
  headingId,
  testId,
}: LaunchPadSectionProps) {
  return (
    <section aria-labelledby={headingId} data-testid={testId}>
      {showSeparator && <Separator className="mb-6" />}
      <div className="mb-4">
        <h2 id={headingId} className="text-lg font-semibold tracking-tight">
          {title}
        </h2>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {children}
    </section>
  );
}
